import DashboardLayout from '../../layout/DashboardLayout.vue'
import AuthLayout from '../../layout/AuthLayout.vue';

// Page Headers
import DefaultHeader from '../../DefaultHeader'
import StatisticsHeader from '../../Pages/client/Statistics/StatisticsHeader.vue'
import ResellerHeader from '../../Pages/reseller/Statistics/StatisticsHeader.vue'

// General pages
const Packages = () => import(/* webpackChunkName: "Packages" */'../../Pages/general/Packages.vue');
const Contact = () => import(/* webpackChunkName: "Contact" */'../../Pages/general/Contact.vue');
const Help = () => import(/* webpackChunkName: "Help" */'../../Pages/general/Help.vue');
import Account from '../../Pages/general/Account.vue'
const Gallery = ()=>  import(/* webpackChunkName: "Gallery" */'../../Pages/general/Gallery.vue');
const Aps = ()=>  import(/* webpackChunkName: "Aps" */'../../Pages/general/Aps.vue');
const Reviews = ()=>  import(/* webpackChunkName: "Reviews" */'../../Pages/general/Reviews.vue');
const Gift = ()=>  import(/* webpackChunkName: "Gift" */'../../Pages/general/Gift.vue');
const Covid = ()=>  import(/* webpackChunkName: "Covid" */'../../Pages/general/Covid.vue');
const WifiPosts = () => import(/* webpackChunkName: "WifiPosts" */'../../Pages/general/WifiPosts.vue');

// Client pages
const WifiStatistics = ()=>  import(/* webpackChunkName: "WifiStatistics" */'../../Pages/client/Statistics/WifiStatistics.vue');
const MessageService = () => import(/* webpackChunkName: "Message" */'../../Pages/client/MessageService/Main.vue');
const MessageTemplate = () => import(/* webpackChunkName: "Message" */'../../Pages/client/MessageService/Template.vue');
const Configuration = () => import(/* webpackChunkName: "Configuration" */'../../Pages/client/Configuration.vue');
const Campaign = ()=>  import(/* webpackChunkName: "Campaign" */'../../Pages/client/Campaign.vue');
const Guests = () => import(/* webpackChunkName: "Guests" */'../../Pages/client/Guests.vue');
const BillboardPosts = () => import(/* webpackChunkName: "BillboardPosts" */'../../Pages/general/BillboardPosts.vue');
const Credit = () => import(/* webpackChunkName: "Credit" */'../../Pages/general/Credit.vue');
const Invoices = () => import(/* webpackChunkName: "Invoices" */'../../Pages/client/Invoices.vue');


// Auth pages
const Login = ()=>  import(/* webpackChunkName: "Auth" */'../../Pages/auth/Login.vue');
const Register = ()=>  import(/* webpackChunkName: "Auth" */'../../Pages/auth/Register.vue');
const Reset = ()=>  import(/* webpackChunkName: "Auth" */'../../Pages/auth/Reset.vue');
const Verify = ()=>  import(/* webpackChunkName: "Auth" */'../../Pages/auth/Verify.vue');


// Admin pages
const Statistics = () => import('../../Pages/admin/Statistics.vue');
const Devices = () => import('../../Pages/admin/Devices.vue');
const Companies = () => import('../../Pages/admin/Companies.vue');
const BulkRequests = () => import('../../Pages/admin/BulkRequests.vue');
const Billboards = () => import('../../Pages/admin/Billboards.vue');
const Accounts = () =>  import('../../Pages/admin/Accounts.vue');
const Urls = () =>  import('../../Pages/admin/Urls.vue');

const GuestsAdmin = () => import('../../Pages/admin/Guests.vue');
const InvoicesAdmin = ()=>  import('../../Pages/admin/Invoices.vue');

// Reseller
import StatisticsReseller from '../../Pages/reseller/Statistics/Statistics.vue'
const ClientsReseller = () => import('../../Pages/reseller/Clients.vue');
const FormClientReseller = () => import('../../Pages/reseller/FormClient.vue');
const DevicesReseller = () => import('../../Pages/reseller/Devices.vue');

// General routes
let generalRoutes = [
  {
    path: 'account',
    name: 'Account',
    components: {default: Account, header: DefaultHeader},
    alias: ''
  },
  {
    path: 'wifi-statistics',
    name: 'WifiStatistics',
    components: {default: WifiStatistics, header: StatisticsHeader},
  },
  {
    path: 'aps',
    name: 'Aps',
    components: {default: Aps, header: DefaultHeader}
  },
  {
    path: 'reviews',
    name: 'Reviews',
    components: {default: Reviews, header: DefaultHeader}
  },
  {
    path: 'gift',
    name: 'Gift',
    components: {default: Gift, header: DefaultHeader}
  },
  {
    path: 'covid',
    name: 'Covid',
    components: {default: Covid, header: DefaultHeader}
  },
  {
    path: 'guests',
    name: 'Guests',
    components: {default: Guests, header: StatisticsHeader}
  },
  {
    path: 'message/:messageType?',
    name: 'Message',
    components: {default: MessageService, header: DefaultHeader},
  },
  {
    path: 'template/:messageType?',
    name: 'Template',
    components: {default: MessageTemplate, header: DefaultHeader}
  },
  {
    path: 'wifi-posts',
    name: 'WifiPosts',
    components: {default: WifiPosts, header: DefaultHeader}
  },
  {
    path: 'billboard-posts',
    name: 'BillboardPosts',
    components: {default: BillboardPosts, header: DefaultHeader}
  },
  {
    path: 'credit/:paymentStatus?',
    name: 'Credit',
    components: {default: Credit, header: DefaultHeader}
  },
  {
    path: 'invoices',
    name: 'Invoices',
    components: {default: Invoices, header: DefaultHeader}
  },
  {
    path: 'configuration',
    name: 'Configuration',
    components: {default: Configuration, header: DefaultHeader}
  },
  {
    path: 'package',
    name: 'package',
    components: {default: Packages, header: DefaultHeader}
  },
  {
    path: 'gallery',
    name: 'Gallery',
    components: {default: Gallery, header: DefaultHeader}
  },
  {
    path: 'campaign/:adId',
    name: 'Campaign',
    components: {default: Campaign, header: DefaultHeader}
  },
  {
    path: 'contact',
    name: 'Contact',
    components: {default: Contact, header: DefaultHeader}
  },
  {
    path: 'help',
    name: 'Help',
    components: {default: Help, header: DefaultHeader}
  },
];

const routes = [
  // Authentication routes -> starting with /auth
  {
    path: '/auth/',
    component: AuthLayout,
    alias: '',
    children: [
      {
        path: 'login',
        name: 'AuthLogin',
        component: Login,
        alias: '/'
      },
      {
        path: 'register',
        name: 'AuthRegister',
        component: Register
      },
      {
        path: 'reset',
        name: 'AuthReset',
        component: Reset
      },
      {
        path: 'verify',
        name: 'AuthVerify',
        component: Verify
      }
    ]
  },


  // Client router
  {
    path: '/client/',
    component: DashboardLayout,
    children: generalRoutes
  },


  // Admin routes
  {
    path: '/admin/',
    component: DashboardLayout,
    children: [
      {
        path: 'accounts',
        name: 'AccountsAdmin',
        components: {default: Accounts, header: DefaultHeader}
      },
      {
        path: 'guests',
        name: 'GuestsAdmin',
        components: {default: GuestsAdmin, header: DefaultHeader}
      },
      {
        path: 'devices',
        name: 'DevicesAdmin',
        components: {default: Devices, header: DefaultHeader}
      },
      {
        path: 'companies',
        name: 'CompaniesAdmin',
        components: {default: Companies, header: DefaultHeader}
      },
      {
        path: 'bulk-requests',
        name: 'BulkRequestsAdmin',
        components: {default: BulkRequests, header: DefaultHeader}
      },
      {
        path: 'billboards',
        name: 'BillboardsAdmin',
        components: {default: Billboards, header: DefaultHeader}
      },
      {
        path: 'invoices',
        name: 'InvoicesAdmin',
        components: {default: InvoicesAdmin, header: DefaultHeader}
      },
      {
        path: 'urls',
        name: 'UrlsAdmin',
        components: {default: Urls, header: DefaultHeader}
      },
    ].concat(generalRoutes.map(route => route = {...route, name: 'Admin' + route.name }))
  },


  // Reseller
  {
    path: '/reseller/',
    component: DashboardLayout,
    children: [
      {
        path: 'account',
        name: 'Account',
        components: {default: Account, header: DefaultHeader},
      },
      {
        path: 'statistics',
        name: 'StatisticsReseller',
        components: {default: StatisticsReseller, header: ResellerHeader},
        alias: ''
      },
      {
        path: 'clients',
        name: 'ClientsReseller',
        components: {default: ClientsReseller, header: DefaultHeader}
      },
      {
        path: 'client-form',
        name: 'FormClientReseller',
        components: {default: FormClientReseller, header: DefaultHeader}
      },
      {
        path: 'devices',
        name: 'DevicesReseller',
        components: {default: DevicesReseller, header: DefaultHeader}
      },
    ].concat(generalRoutes.map(route => route = {...route, name: 'Reseller' + route.name }))
  },


  // Not Found
  {
    path: '*',
    // Funkcija se evaluira pri svakoj navigaciji (ne jednom na boot-u). Ako role nije validan
    // (npr. null pri otvaranju /company/ bez prijave), vodi na login umesto na nepostojecu putanju
    // tipa "/null/" koja opet pada na "*" -> beskonacna redirect petlja ("Maximum call stack size exceeded" / beli ekran).
    redirect: () => {
      const role = localStorage.getItem('role');
      return ['admin', 'reseller', 'client'].includes(role) ? '/' + role + '/' : '/auth/login';
    }
  }
];

export default routes
